import { cva } from 'class-variance-authority'

export const ModalStyles = cva([], { variants: {} })
